import React, { useState, useEffect,useRef } from 'react';
import { Tabs, Table, Button, Form, Input, Select, Upload, Spin, Modal, DatePicker } from 'antd';
import { CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined,PlusOutlined, EyeOutlined } from '@ant-design/icons';
import moment from 'moment';//日期格式化导包
import PopupFrame from '../../component/popupFrame/popupFrame';
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import Message from '../../component/message/message';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import trans from './translation';
import './userAccountManagementAcademicStaff.css';
import UploadModal from './uploadModal';
import CohortProgModal from './cohortProgModal';
const { TabPane } = Tabs;
const { confirm } = Modal;
import ImgCrop from 'antd-img-crop';
const UserAccountManagementAcademicStaffReport = (props) => {
    const [form] = Form.useForm();
    const messageRef = useRef();
    const [tabIndex, setTabIndex] = useState("1");
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tables2, setTables2] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [tablesCount2, setTablesCount2] = useState(0);
    const [current2, setCurrent2] = useState(1);
    const [pageSize2, setPageSize2] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [groupMemberTables, setGroupMemberTables] = useState([]);
    const [isUpload, setIsUpload] = useState(false);
    const [userID, setUserID] = useState("");
    const [academicStaffModel, setAcademicStaffModel] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [isDisabled, setIsDisabled] = useState(true);
    const [defaultDate, setDefaultDate] = useState(moment());
    const [isCohortProgModal, setIsCohortProgModal] = useState(false);
    const [cohortProg, setCohortProg] = useState({});
    const [progList, setProgList] = useState([]);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [imageFile, setImageFile] = useState([]);
    const imageNum = 1;
    useEffect(() => {
        searchAllProgramme()
        search(pageSize, 1, "N");

    }, []);
    const tableColumns = {
        academicStaffAcctId: "academicStaffAcctId",
        staffName:"staffName",
        activeInd: "activeInd",
        inactiveDate: "inactiveDate",
        progTitle:"baseProgId",
    }
    
    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else if ("reset" === flag) {
            model = {}
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("academicStaff/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));

    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (checkboxState.length === 1 && Config.funcInfo.canUpdate === "Y") {
                    edit();
                } else if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                setIsDisabled(true)
                setTables2([])
                search(pageSize, current, "Y");
            }
        }
    }

    const searchAllProgramme = () => {
        Base.callBackApi("commonDropDown/searchAllProgramme", {}).then((data) => {
            if ("SUCCESS" === data.msg) {
                setProgList(data?.object ?? []);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const searchStaffRole = (pageSizeNew, currentPageNew, flag, isShowMsg,userId) =>{
        const staffRoleModel = {};
        staffRoleModel.page = currentPageNew;
        staffRoleModel.startRow = (currentPageNew - 1) * pageSizeNew;
        staffRoleModel.pageSize = pageSizeNew;
        staffRoleModel.sysUserId = userId
        Base.callBackApi("academicStaff/getStaffUserRoleList", staffRoleModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(staffRoleModel)));
                }
                setTablesCount2(data?.object?.total ?? 0);
                setTables2(data?.object?.list ?? []);
                setCurrent2(currentPageNew);
                setPageSize2(pageSizeNew);
                
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const add = () => {
        messageShowHandler();
        setGroupMemberTables([]);
        setImageFile([])
        setTables2([])
        setFlag("add");
        setTabIndex("2");
        initForm({ activeInd: 'Y' });
    }
    const download = () => {
        setIsUpload(true)
    }

    const selectProg = () => {
        setIsCohortProgModal(true)
    }

    const update = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        messageShowHandler();
        
        searchById(model.academicStaffId)
        setTabIndex("2");
        setFlag("edit");
    }


    const edit = () => {
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            academicStaffAcctId: model.academicStaffAcctId ?? '',
            firstName: model.firstName ?? '',
            lastName: model.lastName ?? '',
            receiveNotiInd: model.receiveNotiInd ?? '',
            progId: model.progId ?? '',
            staffSaluation: model.staffSaluation ?? '',
            teacherCategory: model.teacherCategory ?? '',
            email: model.email ?? '',
            progTitle: model.progTitle ?? '',
            baseProgId: model.baseProgId ?? '',
            inactiveDate: model.inactiveDate ? moment(moment(model.inactiveDate).format(Config.dateFormat5), Config.dateFormat5) : null,
            activeInd: model.activeInd ?? '',
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        clearSelect();
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let model = academicStaffModel;
        model.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("academicStaff/delete", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setSearchModel({});
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const disabledDate = current => {
        return current && current > moment().endOf('day');
    };

    const handleChange = (value) => {
        if(value ==='N'){
            form.setFieldValue('inactiveDate',moment());
            setIsDisabled(false)
        }else{
            form.setFieldValue('inactiveDate',null);
            setIsDisabled(true)
        }
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    /**关闭图片弹窗 */
    const handleCancel = () => {
        setPreviewVisible(false);
    }

    /**查看图片 */
    const handlePreview = (file) => {
        setPreviewImage(file.url || file.thumbUrl);
        setPreviewVisible(true);
    }

    const handleRemove = (file) => {
        confirm({
            content: trans.deleteImg[Config.backLang],
            okText: trans.ok[Config.backLang],
            okType: 'danger',
            cancelText: trans.cancel[Config.backLang],
            onOk() {
                let index = imageFile.findIndex(item => item.uid == file.uid);
                let fileList = JSON.parse(JSON.stringify(imageFile));
                fileList.splice(index, 1);
                setImageFile(fileList);
            },
            onCancel() {
            },
        });
        return false;
    }

    /**图片改变事件 */
    const handleImgChange = (file) => {
        let fileList = file.fileList;
        file = file.file;
        if (file.status === "removed") {
            let index = imageFile.findIndex(item => item.uid == file.uid);
            let fileList = JSON.parse(JSON.stringify(imageFile));
            fileList.splice(index, 1)
        } else {
            const reader = new FileReader();
            reader.readAsDataURL(file.originFileObj);
            reader.onload = (e) => {
                fileList[fileList.length - 1].originUrl = e.target.result;
                fileList[fileList.length - 1].imgStatus = "NEW";
            }
        }
        setImageFile(fileList);
    }

    const checkImg = (value) => {
        if (!!imageFile && imageFile.length > 0 && !!value) {
            let list = value.fileList;
            if (list.find(item => item.status === "uploading")) {
                return Promise.reject(trans.awaitImg[Config.backLang]);
            }
            if (list.find(item => item.status === "error")) {
                return Promise.reject(trans.loseImg[Config.backLang]);
            }
        }
        return Promise.resolve();
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div>{trans.settingsImg[Config.backLang]}</div>
        </div>
    );

    const onFinish = (model) => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        let url = "";
        if (flag === "add") {  
            url = "academicStaff/insert";
        } else if (flag === "edit") {
            url = "academicStaff/update";
            model.academicStaffId = academicStaffModel.academicStaffId;
            model.userID = userID;
            model.lastUpdatedDate = academicStaffModel.lastUpdatedDate;
        }
        if (imageFile && imageFile.length > 0) {
            model.academicPhotoModel = {
                status: imageFile[0].imgStatus,
                url: imageFile[0].originUrl,
            };
        }
        model.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi(url, model).then((data) => {
            if ("SUCCESS" == data.msg) {
                searchById(data.object)
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false)
        });
    }

    const searchById = (model) => {
        setIsLoading(true);
        Base.callBackApi("academicStaff/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setFlag("edit");
                let file = [];
                if (model.academicPhoto) {
                    file.push({
                        url: Config.academicPhotoImg + model.academicPhoto + '?' + Config.sasToken,
                        originUrl: model.academicPhoto + '?' + Config.sasToken,
                        imgStatus: "OLD"
                    })
                }
                setImageFile(file);
                setAcademicStaffModel(model)
                setUserID(model.userId)
                handleChange(model.activeInd)
                searchStaffRole(pageSize2,1,"N",false,model.userId)

                initForm(model)
                setAcademicStaffModel(model)
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoading(false));
    }

    const cancel = () => {
        messageShowHandler();
        clearSelect();
        setGroupMemberTables([]);
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        setAcademicStaffModel(model)
        setIsDeleteFrame(true);
        setDeleteTipText("Academic Staff ID" + ":" + model.academicStaffAcctId + "")
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }


    const uploadClose = (flag) => {
        // if (flag) {
        //     if (!(Config.userInfo.role.roleCode === "SYS_ADMIN" || Config.userInfo.role.roleCode === "ADMIN") || searchModel.customerMgtId) {
        //         search(pageSize, 1, "N");
        //     }
        //     errFrameShow("success", trans.importSuccess[Config.backLang]);
        // }
        setIsUpload(false);
    }

    const uploadCohortClose = (flag, model1) => {
        if (flag) {
            setCohortProg({
                ...cohortProg,
                progId: model1.progId,
                progTitle: model1.progTitle ?? "",
            })
            setSearchModel(model => {
                return { ...model, ...{ progTitle: model1.progTitle, baseProgId: model1.progId, } };
            });
            form.setFieldsValue({
                progTitle: model1.progTitle ?? "",
                baseProgId: model1.progId ?? '',
            });
        }
        setIsCohortProgModal(false);
    }

    

    /*eslint-disable*/
    const columns = [
        {
            title: 'CNA',
            dataIndex: 'academicStaffAcctId',
            className: 'tableWidth17',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'academicStaffAcctId') },
        },
        {
            title: 'Academic Name',
            dataIndex: 'staffName',
            className: 'tableWidth17',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'staffName') },
            render: (text, record) => record.firstName + ' ' + record.lastName
        },
        {
            title: "Base Programme",
            dataIndex: 'progTitle',
            className: 'tableWidth18',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'baseProgId') },
        },
        {
            title: "Staff Saluation",
            dataIndex: 'staffSaluation',
            className: 'tableWidth12',
        },
        {
            title: "Email",
            dataIndex: 'email',
            className: 'tableWidth20',
        },
        {
            title: "Status",
            dataIndex: 'activeInd',
            className: 'tableWidth8',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'activeInd') },
            render: (text) => ContextHandler.getMapValue('activeMap', text)
        },
        {
            title: "Inactive Date",
            dataIndex: 'inactiveDate',
            className: 'tableWidth12',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'inactiveDate') },
            render: (text) => text!=null?moment(text).format(Config.dateFormat5):null
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: 'sysControls',
            fixed: 'right',
            width: 90,
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)}  hidden={Config.funcInfo.canUpdate === "N"}><EyeOutlined /> {trans.view[Config.backLang]}</div>
            </div>
        },
    ];

    const columns2 = [
        {
            title: 'Role Code',
            dataIndex: 'roleCode',
            className: 'tableWidth22',
        },
        {
            title: "Programme Code",
            dataIndex: 'progCode',
            className: 'tableWidth22',
        },
        {
            title: "Programme Name",
            dataIndex: 'progTitle',
            className: 'tableWidth22',
        },
        {
            title: "Job App Standing Approval",
            dataIndex: 'jobappStandApproveInd',
            className: 'tableWidth17',
            render: (text) => ContextHandler.getMapValue('indStatusMap', text)
        },
        {
            title: "WPA Standing Approval",
            dataIndex: 'wpaStandApproveInd',
            className: 'tableWidth17',
            render: (text) => ContextHandler.getMapValue('indStatusMap', text)
        },
    ];

    return (
        <div id="container" className="template userAccountManagementAcademicStaff">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose}  deleteTipText={deleteTipText}/> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysSearchRow sysSearchBox'>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysTitle ">{trans.academicStaffId[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.academicStaffAcctId || ''}
                                                placeholder={trans.academicStaffId[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('academicStaffAcctId', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle ">{trans.academicStaffName[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.staffName || ''}
                                                placeholder={trans.academicStaffName[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('staffName', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                            <div className="sysTitle">{trans.programme[Config.backLang]}</div>
                                            <div className="sysButtonSearchInput">
                                                <Input type="text" value={searchModel.progTitle || ''} disabled
                                                        placeholder={trans.programme[Config.backLang]}
                                                         />
                                                <Input type="text" value={searchModel.baseProgId || ''} disabled hidden
                                                    placeholder={trans.programme[Config.backLang]}
                                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                    onChange={(e) => searchChange('baseProgId', e.target.value)} />
                                            </div>
                                            <Button className="sysBtn btnBlue" onClick={() => { setIsCohortProgModal(true) }}>Select</Button>
                                    </div>
                                    <div className='sysSearchButton'>
                                        <Button className="sysBtn btnBlue" type="primary"  onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 1500 }}
                                    rowKey="academicStaffId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                //是否显示可以设置几条一页的选项
                                        onChange: onChange,                  //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                        total: tablesCount,        //总共多少条数据
                                        current: current,       //当前页
                                        pageSize: pageSize,  //每页显示多少条数据
                                        defaultCurrent: 1,          //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={trans.userAccountManagementAcademicStaff[Config.backLang]} forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">{trans.academicStaffId[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="academicStaffAcctId"
                                                
                                                rules={[
                                                    { required: true, message: trans.userIdIsNull[Config.backLang] },  
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.academicStaffId[Config.backLang]} maxLength={11} disabled/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Email</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="email"
                                                rules={[
                                                    { required: true },
                                                    { pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: "Incorrect Email format." },
                                                ]}
                                            >
                                                <Input type="text" placeholder="Email" maxLength={50} disabled/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">{trans.firstName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="firstName"
                                                rules={[
                                                    { required: true, message: trans.firstNameIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text"
                                                    placeholder={trans.firstName[Config.backLang]} maxLength={50}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">{trans.lastName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="lastName"
                                                rules={[
                                                    { required: true, message: trans.lastNameIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text"
                                                    placeholder={trans.lastName[Config.backLang]} maxLength={50}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">{trans.academicStaffGivenName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="staffSaluation"
                                                rules={[
                                                    { required: true, message: trans.staffSaluationIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.academicStaffGivenName[Config.backLang]} maxLength={10} disabled/>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">{trans.notificationInd[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="receiveNotiInd"
                                                rules={[
                                                    { required: true, message: trans.notificationIndIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select className='sysSelect'>
                                                    <Option value=''></Option>
                                                    {context.indStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">{trans.baseProgId[Config.backLang]}</div>
                                        <div className="sysInput btnInput">
                                            <Form.Item
                                                name="progTitle"
                                            >
                                                <Input type="text" className='BUttonProgramme' placeholder={trans.baseProgId[Config.backLang]} disabled/>
                                            </Form.Item>
                                        </div>
                                        <Button type="primary" className='sysBtn btnBlue' onClick={selectProg}>Select</Button>
                                    </div>
                                    <div className='sysCol' hidden>
                                        <div className="sysParam sysParamInput">{trans.baseProgId[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="baseProgId"
                                            >
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className='sysRow'>
                                     <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">{trans.status[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="activeInd"
                                                rules={[
                                                    { required: true, message: trans.activeIndIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select className='sysSelect' onChange={handleChange} disabled>
                                                    <Option value=''></Option>
                                                    {context.activeMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    
                                    {isDisabled ?
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">{trans.academicStaffProgramme[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="inactiveDate"
                                                >
                                                    <DatePicker placeholder="Inactive Date" disabled />
                                                </Form.Item>
                                            </div>
                                        </div> : <div className='sysCol'>
                                            <div className="sysParam sysParamInput mustFill">{trans.academicStaffProgramme[Config.backLang]}</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="inactiveDate"
                                                    rules={[
                                                        { required: true, message: trans.inactiveDateIsNull[Config.backLang] },
                                                    ]}
                                                >

                                                    <DatePicker placeholder="Inactive Date"  disabled
                                                    value={defaultDate}
                                                    disabledDate={disabledDate}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    }
                                    
                                </div>

                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Profile Picture</div>
                                        <div className="sysInput" >
                                            <Modal title="Enlarged View" visible={previewVisible} footer={null} onCancel={handleCancel}>
                                                <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                            </Modal>
                                            <Form.Item
                                                name="img"
                                                rules={[
                                                    { validator: (rule, value) => checkImg(value) }
                                                ]}
                                            >
                                                <ImgCrop rotationSlider aspect={1 / 1} modalTitle="Edit Picture">

                                                    <Upload disabled
                                                        action={Config.uploadTestServer}
                                                        key={"1"}
                                                        accept=".png, .jpg, .jpeg"
                                                        listType="picture-card"
                                                        fileList={imageFile}
                                                        onPreview={handlePreview}
                                                        onRemove={handleRemove}
                                                        onChange={(file) => handleImgChange(file)}>
                                                        {imageFile.length >= imageNum ? null : uploadButton}
                                                    </Upload>
                                                </ImgCrop>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>

                                <div className="sysBodyRow">
                                    <div className="userRoleTitleRow">Staff Role (Setup in Programme Parameters)</div>
                                    
                                </div>
                                <div className="sysTable" id="tableOne">

                                    <Table
                                        scroll={{ x: 1500 }}
                                        rowKey="roleId" //Key值
                                        columns={columns2} //列名
                                        dataSource={tables2} //数据
                                        pagination={{  //分页
                                            showSizeChanger: true,                //是否显示可以设置几条一页的选项
                                            onChange: onChange,                  //上页下页或者跳页方法
                                            onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                            total: tablesCount2,        //总共多少条数据
                                            current: current2,       //当前页
                                            pageSize: pageSize2,  //每页显示多少条数据
                                            defaultCurrent: 1,          //默认当前页为1
                                            size: "small"
                                        }}
                                    />
                                        
                                </div>
                                <div className="sysSaveButton">
                                    {/* <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit">{trans.save[Config.backLang]}</Button> */}
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
            {isUpload && <UploadModal onClose={uploadClose} />}
            {isCohortProgModal && <CohortProgModal onClose={uploadCohortClose} />}
        </div>
    )

}

export default UserAccountManagementAcademicStaffReport;